import { render, staticRenderFns } from "./Accordion.vue?vue&type=template&id=31579654&scoped=true&"
import script from "./Accordion.vue?vue&type=script&lang=js&"
export * from "./Accordion.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../var/task/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "31579654",
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/var/task/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('31579654')) {
      api.createRecord('31579654', component.options)
    } else {
      api.reload('31579654', component.options)
    }
    module.hot.accept("./Accordion.vue?vue&type=template&id=31579654&scoped=true&", function () {
      api.rerender('31579654', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "tmp/tmp-2QqgahwH2wRWz/JS/comp/Accordion.vue"
export default component.exports